import {
    Button,
    Card,
    CardContent,
    CardHeader,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Divider
  } from '@material-ui/core';
  import { makeStyles } from '@material-ui/styles';
  import PropTypes from 'prop-types';
  import React, { useEffect } from 'react';
  import { useTranslation } from 'react-i18next';
  import { connect } from 'react-redux';
  import DefectPage from 'src/components/TriageDefectPage';
  import {
    addDefects,
    addLabours,
    addMaterials,
    getDefectRequest,
    getLabourRequest,
    getMaterialRequest,
    resetDefects,
    resetLabours,
    resetMaterials
  } from '../store/actions';
  import { setTask } from '../store/actions/taskActions';
  
  const useStyles = makeStyles(theme => ({
    root: {},
    contentH: {
      minHeight: 430
    },
    cardsMax: {
      maxHeight: 550,
      minHeight: 550
    }
  }));
  
  function Hizmet({
    ReceiptNo,
    readonly,
    tasks,
    defectReducer,
    labourReducer,
    materialReducer,
    matchedPairsArray,
    handleAddMatchedPairs
  }) {
    const classes = useStyles();
    const { t } = useTranslation('work_order');
    const [open, setOpen] = React.useState(false);
    const [Uyari, setUyari] = React.useState('');
    const [garantiTipi, setgarantiTipi] = React.useState(0);
    const [garantiTipiText, setgarantiTipiText] = React.useState('');
    const [Uyil, setUyil] = React.useState('');
    const [Udonem, setUdonem] = React.useState('');
    const [SeriNo, setSeriNo] = React.useState('');
    const [Barcode, setBarcode] = React.useState('');
    const [Model, setModel] = React.useState('');
    const HizmetData = tasks.tasks.filter(
      d => parseInt(d.ReceiptNo) === parseInt(ReceiptNo)
    );
    const handleClose = () => {
      setOpen(false);
    };
  
    if (
      HizmetData[0]?.ModelCode === undefined ||
      HizmetData[0]?.ModelCode === '' ||
      HizmetData[0]?.ModelCode === null ||
      HizmetData === undefined
    ) {
      return (
        <Card>
          <CardHeader title={t('Urun_Kontrolu')} />
          <Divider />
          <CardContent className={classes.contentH}>
            {t('Urun_sec_mesaji')}
          </CardContent>
        </Card>
      );
    }
  
    const loading =
      defectReducer.loading || materialReducer.loading || labourReducer.loading;
  
  console.log("MATCHED: " + JSON.stringify(matchedPairsArray));
  
    return (
      <div>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title" color="primary">
            {t('Bilgilendirme')}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {Uyari}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              {t('Tamam')}
            </Button>
          </DialogActions>
        </Dialog>
        {defectReducer.Data.length === 0 && !window.navigator.onLine ? (
          <Card className={classes.cardsMax}>
            <CardHeader title={t('Offline_Title')} />
            <Divider />
            <CardContent className={classes.contentH}>
              {t('Offline_Message')}
            </CardContent>
          </Card>
        ) : (
          <DefectPage
            matchedPairsArray={matchedPairsArray ? matchedPairsArray : []}
            handleAddMatchedPairs={handleAddMatchedPairs}
            ReceiptNo={ReceiptNo}
            garantiTipi={garantiTipi}
            garantiTipiText={garantiTipiText}
            readonly={readonly}
            kulModelKodu={HizmetData[0]?.ModelCode}
            Uyil={Uyil}
            Udonem={Udonem}
            SeriNo={SeriNo}
            Barcode={Barcode}
            Model={Model}
          />
        )}
      </div>
    );
  }
  
  Hizmet.propTypes = {
    className: PropTypes.string
  };
  
  export default connect(
    state => ({
      tasks: state.tasks1,
      defectReducer: state.defectReducer,
      labourReducer: state.labourReducer,
      materialReducer: state.materialReducer,
      resetDefects: state.resetDefects,
      resetLabours: state.resetLabours,
      resetMaterials: state.resetMaterials
    }),
    {
      resetDefects,
      resetLabours,
      resetMaterials,
      getDefectRequest,
      getLabourRequest,
      getMaterialRequest,
      addDefects,
      addLabours,
      addMaterials,
      setTask
    }
  )(Hizmet);
  